import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import * as APP from "../redux_store/appState";
import BSL_Select from "../components/BSL_Select";
import { updateJobParameter } from "../redux_store/jobState";
import { takeControl } from "../redux_store/jobStateHelper";
import BSL_Button from "../components/BSL_Button";

const useStyles = makeStyles({
    root: {},
    orderLock: {
        position: "absolute",
        top: "86px",
        width: "100%",
        zIndex: "1",
        background: "#dedfe5",
        color: "black",
        padding: "10px 170px 10px 90px",
        display: "flex",
        zIndex: 55,
        opacity: 1, // Initial opacity
        transition: "opacity 0.5s", // Transition effect for opacity
    },
    button: {
        marginLeft: "10px",
    },
});

export default function LockBar(props) {
    const { openMessageBox } = props;

    const classes = useStyles();
    const dispatch = useDispatch();
    // const [password, setPassword] = React.useState("");
    const app = useSelector((state) => state.app);
    const job = useSelector((state) => state.job);
    const tool_drawer_width = useSelector((state) => state.app?.designer?.[APP.TOOL_DRAWER_WIDTH]);
    const right_padding = (tool_drawer_width && tool_drawer_width > 0 ? tool_drawer_width : 0) + 10;

    const unlock = () => {
        if (app.user.Role >= 90) {
            openMessageBox({
                title: UNLOCKED ? "Lock Job" : "Unlock Job",
                message: [
                    <>
                        This job has been {UNLOCKED ? "UNLOCKED" : "locked"}. Are you sure you would like to{" "}
                        {UNLOCKED ? "lock" : "UNLOCK"} it?
                    </>,
                ],
                primaryActionText: UNLOCKED ? "LOCK" : "UNLOCK",
                secondaryActionText: "CANCEL",
                primaryAction: () => {
                    dispatch(APP.toggleDesigner(APP.UNLOCKED));
                },
            });
        }
    };

    const takeControlConfirm = () => {
        openMessageBox({
            title: "Take Control of Job",
            message: [
                <>
                    Are you sure you would like to take control of editing this job? If you continue, the job will
                    update from the server.
                </>,
            ],
            primaryActionText: "TAKE CONTROL",
            secondaryActionText: "CANCEL",
            button1Id: "Confirm-Control-Job",
            primaryAction: () => {
                dispatch(APP.setDesignerLoadingBackdrop("REQUESTING CONTROL OF JOB #" + job.id));
                dispatch(takeControl(APP.UNLOCKED));
            },
        });
    };

    const read_review_notes = () => {
        let message = [];

        // if (props?.job?.OrderReviewMessage) {
        //     let message_lines = props?.job?.OrderReviewMessage.split("\n");
        //     for (let str of message_lines)
        //         message.push(
        //             <>
        //                 {str}
        //                 <br />
        //             </>
        //         );
        // } else {
        //     message.push(
        //         <>
        //             {"*No Notes*"}
        //             <br />
        //         </>
        //     );
        // }

        if (order_review_message) {
            let message_lines = order_review_message.split("\n");
            for (let str of message_lines)
                message.push(
                    <>
                        {str}
                        <br />
                    </>
                );
        } else {
            message.push(
                <>
                    {"*No Notes*"}
                    <br />
                </>
            );
        }
        openMessageBox({
            title: "Review Notes",
            message: message,
        });
    };

    if (!job) return null;

    const UNLOCKED = app.designer[APP.UNLOCKED];

    const ordered = job?.OrderStatus === "ORDERED";
    const locked = job?.OrderStatus === "PENDING";
    const reviewed = job?.OrderStatus === "REVIEWED";
    const accepted = job?.OrderStatus === "ACCEPTED";

    let order_status = job?.OrderStatus ? job?.OrderStatus?.toUpperCase() : "";
    let order_status_value = order_status;
    let order_review_message = job?.OrderReviewMessage ? job?.OrderReviewMessage : "";
    const warning_messages = props.warningMessages || [];

    let order_bg_color = "#dedfe5";
    if (UNLOCKED) order_bg_color = "#73a04d";
    if (reviewed) order_bg_color = "darkorange";
    if (accepted) order_bg_color = "#008200";

    if (app.user.Role >= 90) {
        order_status = (
            <BSL_Select
                style={{
                    flex: "initial",
                    padding: "0",
                    margin: "0",
                    marginTop: "-5px",
                }}
                selectStyle={{
                    background: "none",
                    border: "none",
                    color: accepted ? "white" : "black",
                }}
                value={order_status}
                tight={true}
                items={["", "PENDING", "REVIEWED", "ACCEPTED"]}
                onChange={(e) => {
                    if (e.target.value === "") {
                        openMessageBox({
                            title: "REMOVE ORDER STATUS",
                            message: [
                                <>
                                    This job has been set to ORDERED. Are you sure you would like to remove its ORDER
                                    status?
                                </>,
                            ],
                            primaryActionText: "REMOVE ORDER STATUS",
                            secondaryActionText: "CANCEL",
                            primaryAction: () => {
                                dispatch(
                                    updateJobParameter(null, {
                                        OrderStatus: e.target.value,
                                    })
                                );
                            },
                        });
                    } else {
                        dispatch(
                            updateJobParameter(null, {
                                OrderStatus: e.target.value,
                            })
                        );
                    }
                }}
            />
        );
    }

    if (job?.App?.Locked) {
        return (
            <div
                className={classes.orderLock}
                style={{
                    background: "orange",
                    color: accepted ? "white" : "black",
                    paddingRight: right_padding + "px",
                }}
            >
                <div style={{ flex: 1, textAlign: "end" }}></div>
                <span
                    onClick={takeControlConfirm}
                    style={{
                        cursor: "pointer",
                        textTransform: "uppercase",
                    }}
                >
                    <LockIcon
                        fontSize="small"
                        style={{
                            verticalAlign: "middle",
                            width: "0.75em",
                            height: "0.75em",
                            marginRight: "5px",
                        }}
                    />
                    {job?.App?.LockMessage}
                    <BSL_Button id="Control-Button" tight className={classes.button} onClick={takeControlConfirm}>
                        TAKE CONTROL
                    </BSL_Button>
                </span>
                <div style={{ flex: 1, textAlign: "start", cursor: "pointer" }}></div>
            </div>
        );
    }

    let lockBar = null;

    lockBar = (
        <div
            className={classes.orderLock}
            style={{
                background: "orange",
                color: accepted ? "white" : "black",
                paddingRight: right_padding + "px",
                opacity: `${warning_messages.length > 0 ? 1 : 0}`,
                pointerEvents: `${warning_messages.length > 0 ? "auto" : "none"}`,
            }}
        >
            {warning_messages.length > 0 && (
                <div style={{ flex: 1, pointerEvents: "none" }} className={classes.warningMessages}>
                    {warning_messages.map((message, index) => (
                        <div style={{ textAlign: "center" }} key={index}>
                            {message}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );

    if (!job?.OrderStatus || job?.OrderStatus === "") return lockBar;

    return (
        <>
            <div
                className={classes.orderLock}
                style={{
                    background: order_bg_color,
                    color: accepted ? "white" : "black",
                    paddingRight: right_padding + "px",
                }}
            >
                <div style={{ flex: 1, textAlign: "end" }}>ORDER STATUS: </div>
                {order_status}
                {accepted && app.user.Role >= 90 && <> - AND SENT TO LYVES</>}
                {accepted && app.user.Role < 90 && <> - AND PROCESSED</>}
                {reviewed && (
                    <span onClick={read_review_notes} style={{ cursor: "pointer" }}>
                        ... READ REVIEW NOTES
                    </span>
                )}
                {!reviewed && (
                    <span onClick={unlock} style={{ cursor: "pointer" }}>
                        {UNLOCKED ? (
                            <LockOpenIcon
                                fontSize="small"
                                style={{
                                    verticalAlign: "middle",
                                    width: "0.75em",
                                    height: "0.75em",
                                    marginRight: "5px",
                                }}
                            />
                        ) : (
                            <LockIcon
                                fontSize="small"
                                style={{
                                    verticalAlign: "middle",
                                    width: "0.75em",
                                    height: "0.75em",
                                    marginRight: "5px",
                                }}
                            />
                        )}
                        EDITING IS {UNLOCKED ? "UNLOCKED" : "LOCKED"}
                    </span>
                )}

                <div style={{ flex: 1, textAlign: "start", cursor: "pointer" }}></div>
            </div>
        </>
    );
}
